import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "wrenchFilled"
const WrenchFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.447 3.257C12.525 1.179 15.62.74 18.129 1.938L13.629 6.44C13.336 6.733 13.336 7.208 13.629 7.5L15.75 9.622C16.043 9.914 16.518 9.914 16.81 9.622L21.31 5.12C22.51 7.63 22.07 10.725 19.993 12.803 18.082 14.713 15.314 15.237 12.93 14.38L5.936 21.375C5.35 21.96 4.4 21.96 3.814 21.375L2.625 20.185C2.039 19.6 2.039 18.65 2.625 18.065L9.341 11.346C7.887 8.773 8.254 5.45 10.447 3.257M19.992 3.257 20 3.264 19.985 3.25z" />
        </svg>
      }
    </span>
  )
}
export default WrenchFilledIcon
